module.exports = __webpack_public_path__ + "assets/img/agence_image_001.624d2f25.jpg";